import {
  FETCH_ANM_DETAILS,
  FETCH_ANM_DETAILS_FAILURE,
  FETCH_ANM_DETAILS_SUCCESS,
  UPDATE_ANM_DETAILS,
  UPDATE_ANM_DETAILS_FAILURE,
  UPDATE_ANM_DETAILS_SUCCESS,
  REJECT_ANM_DETAILS,
  REJECT_ANM_DETAILS_FAILURE,
  REJECT_ANM_DETAILS_SUCCESS,
  APPROVE_ANM_DETAILS,
  APPROVE_ANM_DETAILS_FAILURE,
  APPROVE_ANM_DETAILS_SUCCESS,
  FETCH_SUBCENTER_LIST,
  FETCH_SUBCENTER_LIST_SUCCESS,
  FETCH_SUBCENTER_LIST_FAILURE
} from './ANMDetailsActions';

const defaultState = {
  anmDetails: [],
  subCenterList: [],
  isLoading: false,
};

const ANMReducer = (state = defaultState,action) => {
  switch (action.type) {
    case FETCH_ANM_DETAILS:
      return { ...state, isLoading: true };
    case FETCH_ANM_DETAILS_SUCCESS:
      return { ...state, isLoading: false, anmDetails: action.payload };
    case FETCH_ANM_DETAILS_FAILURE:
      return { ...state, isLoading: false, anmDetails: [] };
    case UPDATE_ANM_DETAILS:
      return { ...state, isLoading: true };
    case UPDATE_ANM_DETAILS_SUCCESS:
      return { ...state, isLoading: false };
    case UPDATE_ANM_DETAILS_FAILURE:
      return { ...state, isLoading: false };
    case REJECT_ANM_DETAILS:
      return { ...state, isLoading: true };
    case REJECT_ANM_DETAILS_SUCCESS:
      return { ...state, isLoading: false };
    case REJECT_ANM_DETAILS_FAILURE:
      return { ...state, isLoading: false };
    case APPROVE_ANM_DETAILS:
      return { ...state, isLoading: true };
    case APPROVE_ANM_DETAILS_SUCCESS:
      return { ...state, isLoading: false };
    case APPROVE_ANM_DETAILS_FAILURE:
      return { ...state, isLoading: false };
    case FETCH_SUBCENTER_LIST:
      return { ...state, isLoading: true };
    case FETCH_SUBCENTER_LIST_SUCCESS:
      return { ...state, isLoading: false, subCenterList: action.payload };
    case FETCH_SUBCENTER_LIST_FAILURE:
      return { ...state, isLoading: false, subCenterList: [] };
    default:
      return state;
  }
};

export default ANMReducer;
